import React, { useState, Fragment, useContext, createContext } from "react";
import { Fade, Modal } from "@mui/material";
import { Svg } from "assets";

export const SecondaryModalContext = createContext(null);

export const SecondaryModalProvider = ({ children }) => {
  const [params, setParams] = useState({});
  const [modalInfo, setModalInfo] = useState({});

  return (
    <Fragment>
      <SecondaryModalContext.Provider
        value={{
          params,
          setParams,
          modalInfo,
          setModalInfo,
        }}
      >
        {children}
      </SecondaryModalContext.Provider>
    </Fragment>
  );
};
export const useSecondaryModal = () => {
  const { params, setParams, modalInfo, setModalInfo } =
    useContext(SecondaryModalContext);
  return {
    openSecondary: (params = {}, modalInfo) => {
      setParams(params);
      setModalInfo(modalInfo);
    },
    closeSecondary: () => {
      setParams({});
      setModalInfo({});
    },
    params,
    modalInfo,
  };
};

export const SecondaryModal = () => {
  const { closeSecondary, params, modalInfo } = useSecondaryModal();

  const renderOpen = Object.keys(params).length !== 0;

  return (
    renderOpen && (
      <Modal
        style={{ zIndex: "1405" }}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={renderOpen}
        onClose={() => closeSecondary()}
        closeAfterTransition
        hideBackdrop={false}
      >
        <Fade in={renderOpen}>
          <div
            style={
                {
                    padding: modalInfo?.padding === "noPaddings" ? 0 : '',
                    outline: modalInfo?.padding === "noPaddings" ? 'none' : 'none',
                    maxWidth: modalInfo?.maxWidth ? modalInfo?.maxWidth : 'inherit'
                }
            }
            className={`modal-wrapper ${
              modalInfo?.className ? modalInfo?.className : ""
            }`}
          >
            {!modalInfo?.noShowCloseBtn && (
              <div className="modal-header-style">
                <button
                  type="button"
                  className="close-modal-btn"
                  onClick={() => closeSecondary()}
                >
                  <Svg.CloseSvg />
                </button>
              </div>
            )}
            <div className="modal-body-style">{params}</div>
          </div>
        </Fade>
      </Modal>
    )
  );
};
